// @flow
/** @jsx h */
import { useEffect } from 'preact/hooks';
import { route } from 'preact-router';
import {
  useCheckoutContext,
  useCheckoutDispatchContext,
} from '../../storeProviders/checkoutWidgetStore';
import { useErrorModalContext } from '../../storeProviders/errorModalStore';

type Props = {
  path: string,
  customHandleBackCallback?: Function,
  showConfirmCancel: boolean,
};

export default function CheckoutCustomBackHandler({
  path,
  customHandleBackCallback,
  showConfirmCancel,
}: Props) {
  const checkoutDispatch = useCheckoutDispatchContext();
  const { isErrorModalOpen } = useErrorModalContext();

  useEffect(() => {
    const popStateCallback = (event: any) => {
      route(path);
      if (customHandleBackCallback) {
        customHandleBackCallback();
      }
      checkoutDispatch({
        type: 'STORE_STATE',
        payload: {
          ...(showConfirmCancel
            ? {
                closeIconConfig: {
                  showCloseIcon: true,
                  shouldShowCancellationPopup: true,
                  showCancellationPopup: true,
                },
              }
            : {}),
        },
      });
    };

    const disableBackButton = () => {
      route(path);
      window.addEventListener('popstate', popStateCallback);
    };

    if (!isErrorModalOpen) disableBackButton();

    return () => {
      window.removeEventListener('popstate', popStateCallback);
    };
  }, [showConfirmCancel, path, isErrorModalOpen]);

  return null;
}



// WEBPACK FOOTER //
// ./components/checkoutWidget/CheckoutCustomBackHandler.js